module.exports = __webpack_public_path__ + "static/img/number-employee.b95c212.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/company-profile/number-employee.svg
// module id = jAsE
// module chunks = 1